module.exports = __webpack_public_path__ + "img/parcel-empty.0e4e9a8c.svg";